import Vue from 'vue'
import Vuex from 'vuex'
import api from './components/backend-api'

Vue.use(Vuex);
export default new Vuex.Store({
    state: {
//    	domain: 'https://web-gera.moerth.at/',
//        domain: 'https://mum-gera.moerth.at/',
//        domain: 'https://localhost:8081/',
        domain: 'https://gera.at/',
        siteKey: '6LfxvLEZAAAAAKaBbPzWmwrBN1tS2YBzvDiZqxrc',
    	loginSuccess: false,
        loginError: false,
        errorText: null,
        userData: {
            userId: null,
            userName: null,
            userPass: null,
            roles: [],
            email: null,
            userpic: null,
            passwordchange: null,
            accessToken: null,
            tokenType: null
        },
        modal: {
            show: false,
            message: '',
            color: '',
            type: '',
            buttonText: 'OK'
        },
        story: null
    },
    mutations: {
        login_success(state, payload){
            state.loginSuccess = true;
            state.loginError = false;
            state.errorText = null;
            state.userData.userId = payload.id;
            state.userData.userName = payload.userName;
            state.userData.userPass = payload.userPass;
            state.userData.firstname = payload.firstName;
            state.userData.lastname = payload.lastName;
            state.userData.roles = payload.roles;
            state.userData.email = payload.email;
            state.userData.userpic = payload.userpic;
            state.userData.passwordchange = payload.passwordchange;
            state.userData.accessToken = payload.accessToken;
            state.userData.tokenType = payload.tokenType;
        },
        login_error(state, payload){
            state.loginError = true;
            state.userName = payload.userName;
            state.errorText = payload.accessToken;
        },
        logout(state){
            state.loginSuccess = false;
            state.loginError = false;
            state.userData.userId = null;
            state.userData.userName = null;
            state.userData.userPass = null;
            state.userData.firstName = null;
            state.userData.lastName = null;
            state.userData.roles = [];
            state.userData.email = null;
            state.userData.userpic = null;
            state.userData.passwordchange = null;
            state.userData.accessToken = null;
            state.userData.tokenType = null;
            localStorage.removeItem('storedUser');
            localStorage.removeItem('storedPass');
        },
        resetBadLogin(state){
        	// console.log('reset bad login!!!');
            state.loginSuccess = false;
            state.loginError = false;
            state.errorText = null;
        }
    },
    actions: {
        resetBadLogin({commit}) {
            return new Promise((resolve, reject) => {
                // console.log('ResetBadLogin');
                commit('resetBadLogin');
                resolve('BadLoginReset successful!');
            })
        },
        login({commit}, {user, password}) {
            return new Promise((resolve, reject) => {
                // console.log('Accessing backend with user: "' + user +'"');
//                /auth/signin, { username: user, password: password }
//                api.login(user, password)
                  api.executePostServerAction('/auth/signin', { username: user, password: password })
                    .then(response => {
                        // console.log('Response:');
                        // console.log(response);
                        // console.log('Response Statuscode ' + response.status);
                        // console.log(response.data);
                        if(response.status == 200) {
                            // console.log('Login successful');
                            // place the loginSuccess state into our vuex store
                            let data = response.data;
                            // console.log('DATA TOKEN');
                            // console.log(data.lastname + ' ' + data.firstname);
                            commit('login_success', {
                                id: data.id,
                                userName: user,
                                userPass: password,
                                firstName: data.firstname,
                                lastName: data.lastname,
                                roles: data.roles,
                                email: data.email,
                                userpic: data.userpic,
                                passwordchange: data.passwordchange,
                                accessToken: data.token,
                                tokenType: data.type
                            });
                        } else {
                            console.log('Login failed!!!!');
                            commit('login_error', {
                                userName: user,
                                accessToken: response.token
                            });

                        }
                        resolve(response)
                    })
                    .catch(error => {
                        console.log('Login error!');
                        // console.log('Error: ' + error);
                        console.log(error);
                        // place the loginError state into our vuex store
                        if (error.response == undefined){
                            commit('login_error', {
                                userName: user,
                                accessToken: 'Network error!'
                            });
                            reject('Invalid credentials!');
                            return false;
                        } else if (error.response.status==400){
                            commit('login_error', {
                                userName: user,
                                accessToken: error.response.data.token
                            });
                        }
                        if (error.response.status==500){
                            commit('login_error', {
                                userName: user,
                                accessToken: 'Keine Verbindung mit Server'
                            });
                        }
                        reject('Invalid credentials!')
                    })
            })
        },
        forgetPassword({commit}, {email}) {
            return new Promise((resolve, reject) => {
                console.log('Forget password with email: ' + email);
//                api.forgetPassword(email)
                  api.executePostServerAction('/auth/passwordForget/'+ email)
                    .then(response => {
                        console.log('Response Statuscode ' + response.status);
                        console.log(response.data);
                        if(response.status == 200) {
                            console.log('Mail sent successfuly');
                        } else {
                            console.log('Mail send failed!');
                        }
                        resolve(response)
                    })
                    .catch(error => {
                        console.log('ResetPassword error!');
                        console.log('Error: ' + error);
                        console.log(error.response);
                        // place the loginError state into our vuex store
                        if (error.response.status==400){
                        	console.log(error.response.data.message);
                        }
                        if (error.response.status==500){
                        	console.log(error.response.data.message);
                        	/*
                            commit('login_error', {
                                userName: user,
                                accessToken: 'Server nicht gefunden!'
                            });
                            */
                        }
                        reject('Invalid credentials!')
                    })
            })
        },
        logout({commit}) {
            return new Promise((resolve, reject) => {
                // console.log('Logging Out');
                commit('logout');
                resolve('Logout successful!');
            })
        }
    },
    getters: {
        isLoggedIn: state => state.loginSuccess,
        isPasswordChange:  state => state.passwordchange,
        hasLoginErrored: state => state.loginError,
        getLoginErrorText: state => state.errorText,
        getUserName: state => state.userData.userName,
        getUserPass: state => state.userData.userPass,
        getUserData: state => state.userData,
        getToken: state => state.userData.accessToken,
        getDomain: state => state.domain,
        getUserRoles: state => state.userData.roles,
        getPasswordChange: state => state.userData.passwordchange
    }
})